import PageHero from '../components/PageHero.jsx';
import ResourceList from '../components/ResourceList.jsx';

const EMA_URL = 'https://www.ema.europa.eu/en/medicines/human/EPAR/foscan#product-information';

const resources = [
  { label: 'Healthcare professional information', meta: 'Medical information enquiries', to: '/contact' },
  { label: 'View product information', meta: 'European Medicines Agency', href: EMA_URL },
];

export default function Foscan() {
  return (
    <>
      <PageHero title="Foscan&reg;" />

      <div className="page-shell">
        <div className="page-narrow">
          <ResourceList title="Information" items={resources} />
        </div>
      </div>
    </>
  );
}